import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_COST_CENTERS,
  SET_COST_CENTERS_PAGINATION,
  SET_COST_CENTERS_FILTERS,
  RESET_COST_CENTERS,
  TOGGLE_COST_CENTER,
} from 'cost_centers/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const costCenter = new schema.Entity('costCenters');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'description'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { costCenters: {} },
  result: { costCenters: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ costCenters: payload.records }, { costCenters: [costCenter] }),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    costCenters: {
      ...state.entities.costCenters,
      [meta.id]: { ...state.entities.costCenters[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    costCenters: {
      ...state.entities.costCenters,
      [meta.id]: { ...state.entities.costCenters[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    costCenters: {
      ...state.entities.costCenters,
      [payload.costCenter.id]: { ...payload.costCenter, isLoading: false },
    },
  },
});

export const reducers = {
  [GET_COST_CENTERS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_COST_CENTERS_PAGINATION]: setPagination,
  [SET_COST_CENTERS_FILTERS]: setFilters,
  [RESET_COST_CENTERS]: reset,
  [TOGGLE_COST_CENTER]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/reducers/cost_centers_list_reducers.js